import styled from 'styled-components';

const Button = styled.a``;

export default Button;
